var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetestLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324 304",
    width: 324,
    height: 304,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tileShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "125%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 5,
    floodColor: "#000000",
    floodOpacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 300,
    height: 276,
    rx: 18,
    ry: 18,
    fill: "#FFFFFF",
    filter: "url(#tileShadow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(162 96) scale(1.85) translate(-83.5 -66.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 76,
    height: 68,
    rx: 6,
    ry: 6,
    fill: "#E29253",
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66 28 L 66 56 L 80 66 L 94 56 L 94 28 Z",
    fill: "#990033",
    stroke: "#1A1A1A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 84,
    r: 21,
    fill: "#D81B60",
    stroke: "#1A1A1A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95 84 A 9 9 0 0 1 110 77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 107 73 L 111 77 L 106 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113 84 A 9 9 0 0 1 98 91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101 95 L 97 91 L 102 87"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 222,
    fontFamily: "'Source Sans Pro', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 600,
    fill: "#3A3A3A",
    textAnchor: "middle"
  }, "Batches for Re-Test")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetestLogo);
export default __webpack_public_path__ + "static/media/retest_logo.40aef94d1105900d0a0439185d826883.svg";
export { ForwardRef as ReactComponent };